import Imm from '../support/ImmutableHelpers';
import DataStore from '../support/DataStore';

import {
  AttendanceByDate,
  AttendanceByVendor,
  Status,
} from '../types/shared/Attendance';
import { Market } from '../types/shared/Market';

let dataStore = DataStore.getInstance('app');

let AttendanceActions = {
  updateAttendance(
    market: Market,
    date: string,
    vendorID: string,
    attendanceStatus: Status,
  ) {
    let vendorAttendance = dataStore.get('attendance') || {};
    let newAttendance = Imm.setProperty(
      vendorAttendance,
      market.id,
      (attendanceByDate: AttendanceByDate = {}) => {
        return Imm.setProperty(
          attendanceByDate,
          date,
          (attendanceSpots: AttendanceByVendor = {}) => {
            return Imm.setProperty(attendanceSpots, vendorID, attendanceStatus);
          },
        );
      },
    );
    dataStore.set('attendance', newAttendance);
  },

  removeAttendance(market: Market, date: string, vendorID: string) {
    let vendorAttendance = dataStore.get('attendance');
    if (!vendorAttendance) {
      return;
    }
    let newAttendance = Imm.setProperty(
      vendorAttendance,
      market.id,
      (attendanceByDate: AttendanceByDate = {}) => {
        return Imm.setProperty(
          attendanceByDate,
          date,
          (attendanceSpots: AttendanceByVendor = {}) => {
            let newObject: AttendanceByVendor = {};
            for (let [id, value] of Object.entries(attendanceSpots)) {
              if (id !== vendorID) {
                newObject[id] = value;
              }
            }
            return newObject;
          },
        );
      },
    );
    dataStore.set('attendance', newAttendance);
  },
};

export default AttendanceActions;
